import { connect } from 'react-redux';
import { denormalize } from 'normalizr';

import { schema } from '../../../../../state/schema';
import {
  loadCognitoFormAnswer,
  deleteCognitoFormAnswer,
} from '../../../../../state/modules/cognitoFormAnswers/actions';
import CognitoFormAnswerViewScreen from '../components/CognitoFormAnswerViewScreen';

const mapStateToProps = (state, ownProps) => {
  const cognitoFormAnswer = ownProps.match.params.id
    ? denormalize(
        state.entities.getIn(['cognitoFormAnswers', ownProps.match.params.id]),
        schema.cognitoFormAnswer,
        state.entities.toJS()
      )
    : null;

  return {
    isLoading: state.cognitoFormAnswers.get('isLoading'),
    cognitoFormAnswer: cognitoFormAnswer,
    id: ownProps.match.params.id,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    load: (id, cb) => {
      dispatch(loadCognitoFormAnswer(id, cb));
    },
    remove: (id, cb) => {
      dispatch(deleteCognitoFormAnswer(id, cb));
    },
  };
};

const CognitoFormAnswerViewScreenContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(CognitoFormAnswerViewScreen);

export default CognitoFormAnswerViewScreenContainer;
